import type { USER_ROLE } from 'cpool-constants';
import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

type Arguments = {
    absenceFrom?: Date | string;
    absenceUntil?: Date | string;
    role?: USER_ROLE;
};

export const schemaUserResolver_GetPossibleDelegates = z.array(
    z.object({
        id: z.string(),
        name: z.string(),
    }),
);

export type SchemaUserResolver_GetPossibleDelegates = z.infer<typeof schemaUserResolver_GetPossibleDelegates>;

export type UserResolver_GetPossibleDelegates = Resolver<Arguments, SchemaUserResolver_GetPossibleDelegates>;
